
import * as AOS from '../new_theme/aos';

window.AOS = AOS;

// require("../new_theme/bootstrap.min"); // Rimosso per evitare conflitti - usa solo Bootstrap principale
require("../new_theme/owl.carousel.min");
require("../new_theme/main");
